import QuestionViewStatementMulti from "./QuestionViewStatementMulti";

export default class QuestionViewVerbalEquivalent extends QuestionViewStatementMulti{
	constructor(question) {
		super(question);
	}

	createStatement(spacing = 40) {
		let width = 0;

		// center statement
		this._footer.statement.pivot.x = width * 0.5;
	}

	getHeaderText() {
		const data = P3.assets.json("templates");
		this._answer = this._question.answer;

		const templates = P3.assets.json("templates").templates;
		const split = this._question.template.split("/");
		let template = P3.utils.selectRandom(P3.utils.objectToArray(templates[split[0]][split[1]]));
		let text = template ? template.text : "";

		text = this._replaceValue(text);
		text = this._replaceLocation(data.words.locations, text);
		text = this._replaceUnits(text);

		return text;
	}

	isCorrect() {
		let correctValues = [];
		for (let i = 0; i < this.question.part.length; i++) {
			correctValues.push(this.question.values[this.question.part[i]]);
		}

		if (this._inputValue.length && this._inputValue.length > 0) {
			let count = this._inputValue.length;
			for (let i = 0; i < count; i++) {
				let isCorrect = false;
				let input = this._inputValue[i].value;

				for (const correctValue in correctValues) {
					if(correctValues[correctValue].toString() === input){
						isCorrect = true;
						break;
					}
				}

				if(isCorrect === false)
					return false;
			}

			return true;
		}
	}

	_replaceValue(text){
		let match = text.match(/\[VALUE([0-9])?]/g);
		if (match)
			text = text.replace(match, this._question.temp.value);
		return text;
	}

	_replaceUnits(text){
		let unit = text.match(/\[UNIT([0-9])?]/g);

		if(unit)
			text = text.replace(unit, this.question.units[this.question.units.length - 1].long);

		return text;
	}

	_replaceLocation(locations, text){
		let match = text.match(/\[LOCATION([0-9])?]/g);
		if (match)
			text = text.replace(match, P3.utils.selectRandom(locations));
		return text;
	}

	setAnswer(value) {
		this._inputValue = value;

		if (!Array.isArray(value)) {
			if (value) {
				const str = value.toString();
				this._inputField.label.text = str;
				this._inputField.label.style.fontSize = str.length < 5 ? 40 : 20;
			} else {
				this._inputField.label.text = "?";
				this._inputField.label.style.fontSize = 40;
			}
		}
	}

	initInputField() {
	}
}